import React, { useState, useEffect } from "react";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';
import AllStock from "./AllStock";
import NewStockForm from "./NewStockForm";
import './Stock.css';

const Stock = () => {
    const [activeTab, setActiveTab] = useState('All Stock');
    const [editStockId, setEditStockId] = useState(null);
    const [showEditDrawer, setShowEditDrawer] = useState(false);
    const [drawerMounted, setDrawerMounted] = useState(false);
    const [drawerClosing, setDrawerClosing] = useState(false);

    const userType = localStorage.getItem("usertype");
    const userFullName = (localStorage.getItem("fname") || "") + " " + (localStorage.getItem("lname") || "");

    const handleStockCreated = () => {
        setActiveTab('All Stock');
    };

    // Trigger the drawer's open animation AFTER it mounts (next frame)
    useEffect(() => {
        if (showEditDrawer && !drawerClosing) {
            const id = requestAnimationFrame(() => {
                requestAnimationFrame(() => setDrawerMounted(true));
            });
            return () => cancelAnimationFrame(id);
        }
    }, [showEditDrawer, drawerClosing]);

    const openEditDrawer = (id) => {
        setEditStockId(id);
        setDrawerClosing(false);
        setDrawerMounted(false);   // start in the closed state
        setShowEditDrawer(true);
    };

    const closeEditDrawer = () => {
        if (!showEditDrawer) return;
        setDrawerClosing(true);
        // Wait for the close transition to finish, then unmount
        setTimeout(() => {
            setShowEditDrawer(false);
            setEditStockId(null);
            setDrawerClosing(false);
            setDrawerMounted(false);
        }, 280);
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <SuperAdminSidebar />}
                {userType === "leader" && <LeaderSidebar />}
                {userType === "manager" && <ManagerSidebar />}
                {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                <AdminNavbar pageTitle="Stock" />

                {/* ========== STATIC STATUS CARDS ========== */}
                <div className="stock-stats-bar">
                    <div className="stat-box overdue">
                        <div className="stat-amount">653</div>
                        <div className="stat-label">Overdue</div>
                    </div>
                    <div className="stat-box started">
                        <div className="stat-amount">698</div>
                        <div className="stat-label">Started</div>
                    </div>
                    <div className="stat-box onhold">
                        <div className="stat-amount">0</div>
                        <div className="stat-label">On Hold</div>
                    </div>
                    <div className="stat-box inprogress">
                        <div className="stat-amount">4</div>
                        <div className="stat-label">In Progress</div>
                    </div>
                    <div className="stat-box cancel">
                        <div className="stat-amount">0</div>
                        <div className="stat-label">Cancel</div>
                    </div>
                    <div className="stat-box sold">
                        <div className="stat-amount">32</div>
                        <div className="stat-label">Sold</div>
                    </div>
                </div>

                <div className="stock-main-section">
                    <div className="stock-tabs-container">
                        <button
                            className={`stock-tab-btn ${activeTab === 'All Stock' ? 'active-tab' : ''}`}
                            onClick={() => setActiveTab('All Stock')}
                        >
                            All Stock
                        </button>
                        <button
                            className={`stock-tab-btn ${activeTab === 'New Stock' ? 'active-tab' : ''}`}
                            onClick={() => setActiveTab('New Stock')}
                        >
                            New Stock
                        </button>
                    </div>

                    <div className="stock-content-area">
                        {activeTab === 'All Stock' && <AllStock openEditDrawer={openEditDrawer} refreshTrigger={activeTab} />}
                        {activeTab === 'New Stock' && <NewStockForm onStockCreated={handleStockCreated} currentUserFullName={userFullName} />}
                    </div>
                </div>
            </div>

            {/* ========== EDIT SIDE DRAWER (Smooth) ========== */}
            {showEditDrawer && (
                <>
                    <div
                        className={`sale-order-drawer ${
                            drawerClosing ? 'drawer-closing' : (drawerMounted ? 'drawer-open' : '')
                        }`}
                    >
                        <div className="sale-order-drawer-header">
                            <h3>Edit Stock</h3>
                            <button
                                onClick={closeEditDrawer}
                                className="sale-order-drawer-close"
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>
                        <NewStockForm
                            mode="edit"
                            stockId={editStockId}
                            onStockCreated={() => {
                                closeEditDrawer();
                                setActiveTab('All Stock');
                            }}
                            currentUserFullName={userFullName}
                            onCancel={closeEditDrawer}
                        />
                    </div>

                    <div
                        className={`sale-order-drawer-overlay ${
                            drawerClosing ? 'overlay-closing' : (drawerMounted ? 'overlay-open' : '')
                        }`}
                        onClick={closeEditDrawer}
                    />
                </>
            )}
        </div>
    )
}

export default Stock;